import React from "react";
import AcceptedOrders from "./orders/AcceptedOrders";

const NordrentOrdersPage = (props) => <AcceptedOrders {...props} />;

export default NordrentOrdersPage;
